import { settings } from '@/config/settings/index'
import { Cookies } from '@/libs/cookies/index'
import { Messages } from '@/utilities/messages'
import { PopUps } from '@/utilities/popups'

interface IBrowserInfo {
  browser?: string
  icon?: string
  link?: string
  text?: string
}

export class BrowserExtension {

  // установка куки при уходе с страницы
  public static setCookies(slug: string): void {
    if (!Cookies.get('fseProductNotShow') && slug) {
      Cookies.set('fseProductSlug', slug, { expires: 0.007 })
      if (!(Cookies.get('fseProductClaim') && Cookies.get('fseProductClaim') === slug)) {
        Cookies.set('fseProductClaim', '')
      }
    }
  }

  private selectors: ISelectors = {
    base: '[data-selector="header"]',
  }

  private base: JQuery | null = null

  private productDict = {
    bank_guarantee: 'Банковская гарантия',
    company_loan: 'Кредит на исполнение контракта',
    tender_loan: 'Тендерный кредит',
  }

  public constructor() {
    this.init()
  }

  private init(): void {
    this.offerExtension()
  }

  private offerExtension(): void {
    if ((typeof chrome !== 'undefined') && chrome.runtime && !Cookies.get('fseProductNotShow')) {
      const id = settings.browser_extension_links.chrome.id ? settings.browser_extension_links.chrome.id : ''
      chrome.runtime.sendMessage(id, 'version', ((response) => {
        if (!response && Cookies.get('fseProductSlug')) {
          this.toOfferLoadExt('Chrome')
        }
      }))
    }

    const isFirefox: boolean = (navigator.userAgent.indexOf('Firefox') !== -1) ? true : false
    if (isFirefox && !Cookies.get('fseProductNotShow')) {
      if (typeof window.etpfsNotify === 'undefined') {
        this.toOfferLoadExt('Firefox')
      }
    }
  }

  private toOfferLoadExt(browser: string): void {
    this.addEvent(document, 'mouseout', (e: MouseEvent) => {
      const event: MouseEvent = e ? e : window.event as MouseEvent
      const from: HTMLElement = event.relatedTarget as HTMLElement
      if ((!from || from.nodeName === 'HTML') && event.clientY <= 100 && Cookies.get('fseProductSlug')) {
        this.showPopupExtension(browser)
        Cookies.remove('fseProductSlug')
        Cookies.remove('fseProductClaim')
        Cookies.set('fseProductNotShow', 'true', { expires: 7 })
      }

      return true
    })
  }

  private addEvent(obj: Document, evt: string, fn: (e: MouseEvent) => boolean): void {
    obj.addEventListener(evt, fn, false)
  }

  private showPopupExtension(browser: string): void {
    const obj: IBrowserInfo = this.getBrowserData(browser)

    PopUps.showPopupByContent({
      textContent: Messages.getAppInStore(obj),
    })
  }

  private getBrowserData(browser: string): IBrowserInfo {
    return {
      browser,
      icon: browser.toLowerCase(),
      link: this.getExtLink(browser),
      text: this.getExtText(Cookies.get('fseProductClaim')),
    }
  }

  /* tslint:disable:no-var-requires max-line-length */
  private getExtLink(browser: string): string {
    return settings.browser_extension_links[browser.toLowerCase()].link
  }
  /* tslint:enable:no-var-requires max-line-length */

  private getExtText(isSendClaim: string): string {
    const productName: string = this.getProductName(Cookies.get('fseProductSlug'))

    return isSendClaim !== undefined
      ? `Скачайте плагин для браузера от Финансового супермаркета и отправляйте заявку на услугу
        «${ productName }» в 1 клик!`
      : `Не готовы отправить заявку прямо сейчас? Скачайте плагин для браузера от Финансового
        супермаркета и отправляйте заявку на услугу «${ productName }» в 1 клик, когда она потребуется!`
  }

  private getProductName(slug: string): string {
    return this.productDict[slug]
  }
}
